import style from '~/components/about-page/style.module.css';
import Image from '~/components/common/image';
import { Translate } from '~/i18n';
import Container from '../common/container';
/******************************************************************
 *
 *  THIS COMPONENT WAS GENERATED BY NEXTCRAZY-CLI
 *
 ******************************************************************/

const Vision2030 = () => {
   return (
      <div
         className={`${style['vision-bg']} text-center mt-20 xl:mt-44 relative lg:text-4xl text-2xl font-medium text-white`}>
         <div className="hidden xl:block">
            <Image
               src="/images/about-page/vision2030.svg"
               layout="responsive"
               height="560"
               width="1680"
            />
         </div>
         <div className="pt-6 pb-20 xl:absolute xl:left-0 xl:right-0 top-1/4 md:pb-40 lg:pb-64 xl:pb-20 md:pt-16 lg:pt-32 xl:py-0">
            <div className="pb-6 xl:pb-8">
               <Image src="/images/about-page/2030.svg" height="100px" width="147px" />
            </div>
            <Container className="font-medium">
               <Translate id="about:build massive ecosystem" />
            </Container>
         </div>
      </div>
   );
};

export default Vision2030;
